import { Redirect } from "expo-router";

import { api } from "~/utils/api";

export const Research = () => {
  const [list] = api.research.types.useSuspenseQuery(undefined, {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return <Redirect href={"/research/" + (list?.[0]?.value ?? "bat-12")} />;
};

export default Research;
